import { Col, Typography } from "@commonlibs";
import { RadioButtonGroup } from "ui/common/components/input/RadioButtonGroup/RadioButtonGroup";
import { PermissionsSelectorProps } from "./PermissionsSelector.types";
import { RoleType } from "common/models/role/Role";

export default function PermissionsSelector({ onChange, defaultValue }: PermissionsSelectorProps) {
    const roles = [
        { label: "Administrador Operaciones", value: RoleType.OPERATION_MANAGER },
        { label: "Administrador Servicio al Cliente", value: RoleType.CUSTOMER_SERVICE },
    ];

    function onRadioChange(value: string) {
        onChange("adminPermissions", value);
    }

    return (
        <Col gap={15}>
            <Typography variant="body2Strong" color="primary">
                Selecciona los permisos que tendrá el administrador
            </Typography>
            <RadioButtonGroup defaultValue={defaultValue} onChange={onRadioChange} options={roles} direction="column" />
        </Col>
    );
}
